import React from "react";
import "./cta.scss";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../LanguageContext"; // 👈 import our language hook

const CTA = () => {
  const navigate = useNavigate();
  const { t } = useLanguage(); // 👈 translation function

  return (
    <div className="cta">
      <h2>{t("cta_title")}</h2>
      <p className="primary">{t("cta_description")}</p>

      <button onClick={() => navigate("/contact")}>
        {t("cta_button")}
      </button>
    </div>
  );
};

export default CTA;
